module.exports = __webpack_public_path__ + "media/jackpot1.3ce70fd9.mp3";